import { useMemo } from "react";
import { useApolloClient } from "@apollo/client";
import { OrganizationsService } from "../model/OrganizationsService";

export function useOrganizationService() {
    const client = useApolloClient();
    return useMemo(() => OrganizationsService.create(client), [client]);
}
